import Header from "./components/Header";
import InputForm from "./components/InputForm";
import PreviewTable from "./components/PreviewTable";

function App() {
  return (
    <>
      <Header />
      <section>
        <InputForm />
        <PreviewTable />
      </section>
    </>
  );
}

export default App;
